import { SUPER_HERO_ENTRY_PATH } from './superHeroCampaign';

const RECOVERY_KEY = 'autoclipper:campaign-password-recovery';
const RECOVERY_TTL_MS = 60 * 60 * 1000;
type RecoveryStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function rememberCampaignRecovery(storage: RecoveryStorage, redirect: string | null, now: number): void {
  try {
    if (redirect === SUPER_HERO_ENTRY_PATH) {
      storage.setItem(RECOVERY_KEY, JSON.stringify({ path: SUPER_HERO_ENTRY_PATH, expires: now + RECOVERY_TTL_MS }));
    } else {
      storage.removeItem(RECOVERY_KEY);
    }
  } catch { /* Recovery still works when browser storage is unavailable. */ }
}

export function campaignRecoveryDestination(storage: RecoveryStorage, redirect: string | null, now: number): string {
  if (redirect === SUPER_HERO_ENTRY_PATH) return SUPER_HERO_ENTRY_PATH;
  try {
    const saved = JSON.parse(storage.getItem(RECOVERY_KEY) || 'null');
    if (saved?.path === SUPER_HERO_ENTRY_PATH && Number.isFinite(saved.expires) && saved.expires > now && saved.expires <= now + RECOVERY_TTL_MS) {
      return SUPER_HERO_ENTRY_PATH;
    }
  } catch { /* Ignore expired or invalid non-sensitive routing preferences. */ }
  return '/login';
}
